<div class="selector">
  <mat-button-toggle-group
    name="timePeriod"
    [(ngModel)]="selectedPreset"
    (change)="onPresetChange($event.value)"
    [hideSingleSelectionIndicator]=true
    class="timespan-selector"
  >
    <mat-button-toggle value="day">Tag</mat-button-toggle>
    <mat-button-toggle value="week">Woche</mat-button-toggle>
    <mat-button-toggle value="month">Monat</mat-button-toggle>
    <mat-button-toggle value="year">Jahr</mat-button-toggle>
    <mat-button-toggle value="custom" (click)="openCustomDialog()">Definieren</mat-button-toggle>
  </mat-button-toggle-group>

</div>
